// Generated by CoffeeScript 1.11.1
(function() {
  var LayerId, LayerInfo,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  LayerInfo = require('../layer_info');

  module.exports = LayerId = (function(superClass) {
    extend(LayerId, superClass);

    function LayerId() {
      return LayerId.__super__.constructor.apply(this, arguments);
    }

    LayerId.shouldParse = function(key) {
      return key === 'lyid';
    };

    LayerId.prototype.parse = function() {
      return this.id = this.file.readInt();
    };

    return LayerId;

  })(LayerInfo);

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/layer_info/layer_id.js
// module id = 60
// module chunks = 0